<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="contract.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="contract.contragent"
              [isError]="$any(errors?.contragent)"
              [withAdditionalInfo]="true"
              [clientId]="clientId"
              [showClear]="true"
              [customSearch]="false"
              appendTo="body"></crm-contragent-auto-complete>
            <small
              *ngIf="errors?.contragent"
              class="p-error">
              {{ errors.contragent }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-single-select
              [options]="companies"
              [(selectedItem)]="contract.company"
              [virtualScroll]="true"
              [virtualScrollItemSize]="33"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.company"
              class="p-error">
              {{ errors.company | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Номер</label>
            <crm-input-text
              [(value)]="contract.number"
              [isError]="$any(errors?.number)"></crm-input-text>
            <small
              *ngIf="errors?.number"
              class="p-error">
              {{ errors.number | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дата</label>
            <crm-datepicker
              [(value)]="contract.date"
              [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.date"
              class="p-error">
              {{ errors.date | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0">
            <p-checkbox
              [(ngModel)]="contract.ignoreInAnalytics"
              [binary]="true"
              inputId="ignoreInAnalytics"></p-checkbox>
            <label [for]="'ignoreInAnalytics'">Не учитывать документы в аналитике</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveContract()"></button>

      <button
        *ngIf="(form$ | async)?.isEdit"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteContract()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
